import { useDispatch, useSelector } from 'react-redux';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { useEffect } from 'react';
import { getFaq } from '@/store/cms/faq/actions';

export const useFaqLoader = () => {
  const locale = useSelector(selectLocale);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!locale) {
      return;
    }

    dispatch(getFaq());
  }, [locale]);
};
